module.exports = __webpack_public_path__ + "img/Quility_MP_Schedule-Consultation.62cdda79.svg";